// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3213":"28cdd76bc6ab99af","4938":"4b863a685b149ac7"}[chunkId] + ".css";
};